import makeService from "./makeService";

const adminService = makeService({
  service: "admin",
  subservices: {
    POST: [
      "createAssistant",
      "configurationIds",
      "getAllAssistantsData",

      "getGraph",
      "getOpenAiPromptResponses",
      "makeAssistantLive",
      "getDashboardData"
    ]
  }
});

const accountsService = makeService({
  service: "accounts",
  subservices: {
    POST: ["findAccounts", "findAccountByAssistantId"],
    GET: ["test"]
  }
});

const botPortalService = makeService({
  service: "botPortal",
  subservices: {
    POST: [
      "createDraftAndUpdateTriplets",
      "deleteDraft",
      "editTriplets",
      "getClientName",
      "getLastNotification",
      "createMergeRequest",
      "originalTriplets",
      "tripletsFromDraft"
    ]
  }
});

const conversationService = makeService({
  service: "conversation",
  subservices: { POST: ["find", "get"] }
});

const deploymentService = makeService({
  service: "switch",
  subservices: {
    POST: ["addNewNumber", "deactivateRoom"]
  }
});

const kgviewerService = makeService({
  service: "kgviewer",
  subservices: { POST: ["getGraph", "getVersionsFile"] }
});

const previewService = makeService({
  service: "preview",
  subservices: {
    POST: [
      "createBotForTesting",
      "isBotReadyForTesting",
      "initiateTestCall",
      "isBotPreviewable"
    ]
  }
});

const recordingService = makeService({
  service: "recording",
  subservices: {
    POST: ["get"]
  }
});

const storageService = makeService({
  service: "storage",
  subservices: {
    POST: [
      "downloadFile",
      "getFilesMetaData",
      "uploadImageFile"
    ]
  }
});

export {
  adminService,
  accountsService,
  botPortalService,
  conversationService,
  deploymentService,
  kgviewerService,
  previewService,
  recordingService,
  storageService
};
